import { makeStyles, createStyles } from '@material-ui/styles';
import Markdown from 'markdown-to-jsx';
import React, { FC, ComponentProps } from 'react';
import { LabelStyle } from '../services/layout';
import { Theme } from '@material-ui/core/styles';

export interface LabelProps extends ComponentProps<any> {
  children?: string;
  labelStyle?: LabelStyle;
}

const useStyles = makeStyles((_: Theme) => {
  return createStyles({
    label(props: LabelProps) {
      const style = props.labelStyle;
      const r = style?.textAlign
        ? { textAlign: style.textAlign }
        : {};

      return r;
    },
  });
});

export const FieldLabel: FC<LabelProps & React.HTMLAttributes<HTMLDivElement>> = function (props) {
  
  const classes = useStyles(props);

  if (!props.children) {
    return <div></div>;
  }

  return (
    <div className = { classes.label }>
      <span>
        <Markdown>
          { props.children }
        </Markdown>
      </span>
    </div>
  )
};
